import { useMemo } from 'react';

import { Pair } from '@app/types/pool';

export function usePairTvl(
  ethPrice: string | null | undefined,
  pair: Pair | undefined
) {
  return useMemo(() => {
    if (!ethPrice || !pair) {
      return 0;
    }

    const { token0, token1, reserve0, reserve1, reserveETH, isStable } = pair;

    if (isStable) {
      return +reserveETH * +ethPrice;
    }

    const price0 = +token0.derivedETH * +ethPrice;
    const price1 = +token1.derivedETH * +ethPrice;

    const tvl0 = price0 ? Number(reserve0) * price0 : 0;
    const tvl1 = price1 ? Number(reserve1) * price1 : 0;

    return tvl0 + tvl1;
  }, [ethPrice, pair]);
}
